export default {
    EN: 'en-CA',
    FR: 'fr-CA'
};


// WEBPACK FOOTER //
// ./src/constants/locale/localeTypes.js